import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=8116768c&scoped=true"
import script from "./Classificacao.vue?vue&type=script&lang=js"
export * from "./Classificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8116768c",
  null
  
)

export default component.exports